import React, { useEffect, useState } from "react";
import axios from "axios";
import { PostagemDTO } from "../types";
import styles from "./styles/ShortsSection.module.css";
import ComentariosModal from "./ComentariosModal"; // importa o modal de comentários

interface ShortsSectionProps {
  onRender?: () => void;
}

// Componente para thumbnail com loading
const Thumb: React.FC<{ src: string; alt: string; className?: string }> = ({ src, alt, className }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div className={styles.thumbWrapper}>
      {loading && <div className={styles.thumbLoading}>⏳</div>}
      <img
        src={src}
        alt={alt}
        className={className}
        onLoad={() => setLoading(false)}
        style={{ display: loading ? "none" : "block" }}
      />
    </div>
  );
};

const ShortsSection: React.FC<ShortsSectionProps> = ({ onRender }) => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [shorts, setShorts] = useState<PostagemDTO[]>([]);
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [selectedPostagemId, setSelectedPostagemId] = useState<number | null>(null);
  const [showComentarios, setShowComentarios] = useState(false);

  useEffect(() => {
    axios
      .get<PostagemDTO[]>(`${BASE_URL}/postagens/shorts`)
      .then((res) => {
        setShorts(res.data);
        if (onRender) onRender();
      })
      .catch((err) => console.error("Erro ao carregar shorts:", err));
  }, [BASE_URL, onRender]);

  const abrirVideo = (url: string, postagemId: number) => {
    setVideoUrl(url);
    setSelectedPostagemId(postagemId);
  };
  const fecharVideo = () => setVideoUrl(null);

  if (shorts.length === 0) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Videos of user posts</h3>
      <div className={styles.shortsRow}>
        {shorts.map((short) => {
          const videoFile = short.arquivos.find((a) => a.tipo?.startsWith("video/"));
          if (!videoFile) return null;

          return (
            <div key={short.id} className={styles.shortWrapper}>
              <div
                className={styles.shortCard}
                onClick={() => abrirVideo(`${BASE_URL}${videoFile.url}`, short.id)}
              >
                {short.videoThumbBase64 ? (
                  <Thumb src={short.videoThumbBase64} alt="Short thumbnail" className={styles.videoThumb} />
                ) : (
                  <div className={styles.videoThumbPlaceholder}>🎬</div>
                )}
                <div className={styles.playIcon}>▶</div>
                <div className={styles.shortFooter}>
                  <img
                    src={short.usuarioFotoUrl ? `${BASE_URL}${short.usuarioFotoUrl}` : "/default-avatar.png"}
                    alt={short.usuarioNome}
                    className={styles.shortAvatar}
                  />
                  <span className={styles.shortUsername}>{short.usuarioNome}</span>
                </div>
              </div>
              <div className={styles.shortPackageTitle}>{short.pacoteTitulo}</div>
            </div>
          );
        })}
      </div>

      {/* Modal Lightbox */}
      {videoUrl && selectedPostagemId && (
        <div className={styles.modalOverlay} onClick={fecharVideo}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>

            {/* Botão para abrir ComentariosModal (canto esquerdo) */}
            <button
              className={styles.verPostagemButton}
              onClick={() => {
                setShowComentarios(true);
                fecharVideo();
              }}
            >
              see full post
            </button>

            {/* Botão de fechar (canto direito) */}
            <button className={styles.closeButton} onClick={fecharVideo}>✕</button>

            <video
              src={videoUrl}
              controls
              autoPlay
              className={styles.modalVideo}
            />
          </div>
        </div>
      )}

      {/* Modal de Comentários */}
      {showComentarios && selectedPostagemId && (
        <ComentariosModal
          postagemId={selectedPostagemId}
          show={showComentarios}
          onClose={() => setShowComentarios(false)}
        />
      )}
    </div>
  );
};

export default ShortsSection;
